import { render, staticRenderFns } from "./SAML.vue?vue&type=template&id=00c0f17d&scoped=true"
import script from "./SAML.vue?vue&type=script&lang=js"
export * from "./SAML.vue?vue&type=script&lang=js"
import style0 from "./SAML.vue?vue&type=style&index=0&id=00c0f17d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0f17d",
  null
  
)

export default component.exports